import { IVideoCallTimer } from "@interfaces/videocall/videocall";
import { Dispatch, SetStateAction, createContext } from "react";
import { Socket } from "socket.io-client";

interface IVideoCallSocketContext 
{
    socketVideo: Socket | null,
    createSocket?: (...args: unknown[]) => void,

    time: IVideoCallTimer | undefined, 
    showTimer: boolean,
    expired: boolean,
    counterIsAllowed: boolean,
    setCounterIsAllowed?: Dispatch<SetStateAction<boolean>>,
    resetStates: () => void
}

const defaultVideoCallData: IVideoCallSocketContext = {
    socketVideo: null,
    time: undefined,
    expired: false,
    showTimer: false,
    counterIsAllowed: false,
    resetStates: () => { console.debug("Default reset state"); }
};
export const VideoCallSocketContext = createContext<IVideoCallSocketContext>(defaultVideoCallData);
